import React from "react";
import { Footer, FooterProps } from "@emisgroup/ui-dialog";
import "./Style.scss";

interface CustomFooterProps {
  /**
   * Children to render
   */
  children?: React.ReactNode;
}

type FootProps = FooterProps & CustomFooterProps;

/**
 * Responsible for rendering the dialog footer component
 * @returns dialog footer element
 */
export const UIFooter: React.FC<FootProps> = (props: FootProps) => {

  const { children, className } = props;

  return (
    <Footer
      className={`${className} ui-dialog-footer`}
      {...props}
    >
      {children}
    </Footer>
  );
};
